import type { GraphNode } from "@salesko/contracts";

export function graphSearchText(node: GraphNode) {
  return [
    node.label,
    node.type,
    node.summary,
    node.evidence,
    Object.values(node.data)
      .filter((value) => typeof value === "string" || typeof value === "number" || typeof value === "boolean")
      .join(" ")
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();
}

export function graphSearchScore(node: GraphNode, term: string) {
  if (!term) {
    return 0;
  }

  const label = node.label.toLowerCase();
  const type = node.type.toLowerCase();
  const summary = (node.summary ?? "").toLowerCase();
  const evidence = (node.evidence ?? "").toLowerCase();
  const dataText = Object.values(node.data)
    .filter((value) => typeof value === "string" || typeof value === "number" || typeof value === "boolean")
    .join(" ")
    .toLowerCase();

  if (label === term) {
    return 100;
  }
  if (label.startsWith(term)) {
    return 90;
  }
  if (label.includes(term)) {
    return 80;
  }
  if (type.includes(term)) {
    return 55;
  }
  if (summary.includes(term)) {
    return 40;
  }
  if (dataText.includes(term)) {
    return 30;
  }
  if (evidence.includes(term)) {
    return 15;
  }

  return graphSearchText(node).includes(term) ? 1 : 0;
}
